import { Chat } from '@/components/3d/chat/Chat'
import Experience from '@/components/3d/Experience'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/student/virtual-classroom')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="virtual-classroom-container">
      <Experience />
      <Chat />
    </div>
  )
}
